module.exports = __webpack_public_path__ + "img/img_mail_bi_new.1a6dc81c.png";